import React from 'react';
import type { TaskRow } from '../api/tasks';
import { TASK_WORKFLOW_STATUS_PILL_COLORS, OVERDUE_STATUS_PILL_COLOR } from '../constants/taskStatusPills';
import { isTaskOverdue } from '../utils/formatTaskDate';
import { OVERDUE_FILTER_LABEL } from '../utils/taskStatusFilter';
import './TaskStatusPills.css';

type PillClassName = 'dashboard-pill' | 'tasks-tag-pill' | 'employees-task-pill';

export function TaskStatusPills({
  task,
  pillClassName = 'dashboard-pill',
}: {
  task: TaskRow;
  pillClassName?: PillClassName;
}) {
  const overdue = isTaskOverdue(task);
  return (
    <span className="task-status-pills">
      <span
        className={pillClassName}
        style={{ backgroundColor: TASK_WORKFLOW_STATUS_PILL_COLORS[task.status] ?? '#e5e7eb' }}
      >
        {task.status}
      </span>
      {overdue && (
        <span className={pillClassName} style={{ backgroundColor: OVERDUE_STATUS_PILL_COLOR }}>
          {OVERDUE_FILTER_LABEL}
        </span>
      )}
    </span>
  );
}
